import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { CircularProgress } from 'material-ui/Progress';
import Slide from 'material-ui/transitions/Slide';
import * as regData from '../../../../appConstants'

import find from 'lodash/find'

import * as notes from '../../../actions/agendaitemdetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class AgendaNotes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            setValue: false,
            notes: '',
        };
    }


    handleChange = event => {
        this.setState({ notes: event.target.value });
    };
    handleRequestClose = () => {
        this.props.closeDialog();
        this.setState({ setValue: false, });
    };

    setData = () => {
        // console.log('agenda',this.props)
        this.props.actions.updateNotes({ id: this.props.id, notes: this.state.notes }, this.props.committee_id, this.props.smeetingId);
        // this.setState({ setValue: false, });
    };

    componentDidMount() {
        this.setState({ notes: this.props.notes });
        // console.log("componentDidMount", this.props.notes);
    }
    render() {
        const { id, notes, agendaitemDetails } = this.props;
        let result = null;
        // console.log('props.notes', this.props.notes)
        // console.log('state.notes', this.state.notes)
        // console.log('state.setValue', this.state.setValue)
        if (agendaitemDetails && agendaitemDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        // if (!this.state.setValue && this.props.notes && this.props.notes.length > 0) {
        //     // this.state.notes = this.props.notes ? this.props.notes : '';
        //     // this.setState({ notes: this.props.notes ? this.props.notes : '', });
        //     // this.setState({ setValue: true, });
        // }
        // if (this.state.setValue && !this.props.notes)
        //     this.setState({ setValue: false, notes: '', });
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Agenda Notes</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row p-4">
                            <div className="col-md-12">
                            Please enter the notes
                                <ValidatorForm autoComplete="off" ref="agendanotesform" onSubmit={this.setData.bind(this)}>
                                    <div className="col-12">
                                        <TextValidator margin="normal" className="w-100 mt-0 mb-4 col-md-12"
                                            name="notes" label="" multiline={true}
                                            validators={[regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                            errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                            value={this.state.notes} onChange={this.handleChange.bind(this)} />
                                    </div>
                                </ValidatorForm>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={() => this.refs.agendanotesform.submit()} variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(notes, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AgendaNotes);


// WEBPACK FOOTER //
// ./app/agendaitemdetails/agendaitemlist/agendanotes.js